import { LogoutOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const UserMenu = () => {
    const { currentUser, logout } = useAuth();
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    // Detectar si es dispositivo móvil
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    // Opciones del menú
    const items = [
        {
            key: 'profile',
            icon: <UserOutlined />,
            label: 'Mi Perfil',
            onClick: () => navigate('/perfil'),
        },
        {
            key: 'settings',
            icon: <SettingOutlined />,
            label: 'Configuración',
            onClick: () => navigate('/configuracion'),
        },
        {
            type: 'divider',
        },
        {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: 'Cerrar Sesión',
            onClick: handleLogout,
        },
    ];

    return (
        <Dropdown menu={{ items }} trigger={['click']} placement="bottomRight">
            <Button
                type="text"
                style={{
                    color: 'white',
                    width: isMobile ? 32 : 'auto',
                    height: isMobile ? 32 : 32,
                    padding: isMobile ? 0 : '0 8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <UserOutlined style={{ fontSize: isMobile ? 16 : 14 }} />
                {!isMobile && (
                    <span style={{ marginLeft: 8 }}>
                        {currentUser.firstName}
                    </span>
                )}
            </Button>
        </Dropdown>
    );
};

export default UserMenu; 